import React, { useState } from "react";
import { RejectionReason } from "../../constants/reworkPageTasks"
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { changeDateFormat } from "../../utils";
import './index.scss';

function RejectReason(props) {
    const {
        MarkupList,
    } = props.cicCommentList;
    const { headingText, owner, date } = props;
    const [markups] = useState(MarkupList || []);

    const dateBody = () => {
        const formattedDate = changeDateFormat(String(date));
        return <span>{formattedDate && formattedDate !== "Invalid date" ? formattedDate : "N/A"}</span>;
    };

    const ownerBody = (rowData) => {
        return <span>{owner}</span>;
    };

    return (
        <>
            <div className="wrapperRejectReason">
                <p>{headingText}</p>
                <div>
                    {markups === undefined ? (
                        <h3>{RejectionReason.nomarkup}</h3>
                    ) : (
                        <div className="rejectionTable">
                            <DataTable value={markups}>
                                <Column field="VersionNumber" header={RejectionReason.version} />
                                <Column field="MarkupDate" header={RejectionReason.date} body={dateBody} />
                                <Column field="Assignee" header={RejectionReason.owner} body={ownerBody} />
                                <Column field="Markup" header={RejectionReason.markup} />
                            </DataTable>
                        </div>
                    )}
                </div>
            </div>

        </>
    );
}

export default RejectReason;
